import React from 'react'

import { InfoWindow, Marker } from '@react-google-maps/api'
import PropTypes from 'prop-types'

const PopupMarker = ({ children, position, ...props }) => {
  const [openInfo, setOpenInfo] = React.useState(false)

  return (
    <Marker
      position={ position }
      onClick={ () => setOpenInfo(prevState => !prevState) }
      { ...props }
    >
      {openInfo ? (
        <InfoWindow onCloseClick={ () => setOpenInfo(false) }>
          {children}
        </InfoWindow>
      ) : null}
    </Marker>
  )
}

PopupMarker.propTypes = {
  children: PropTypes.element.isRequired,
  position: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  }).isRequired
}

export default PopupMarker
